import { render, staticRenderFns } from "./setupPaymentBanner.vue?vue&type=template&id=0ba56ee9&scoped=true&"
import script from "./setupPaymentBanner.vue?vue&type=script&lang=js&"
export * from "./setupPaymentBanner.vue?vue&type=script&lang=js&"
import style0 from "./setupPaymentBanner.vue?vue&type=style&index=0&id=0ba56ee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba56ee9",
  null
  
)

export default component.exports